import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { PendingInvite } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

const useGetPendingInvites = ({ matterId }: { matterId: string | undefined }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getPendingInvites = async (): Promise<PendingInvite[]> => {
    const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/pending-invites`, fetchConfigGET);
    return response.json();
  };

  return useQuery([QueryEntity.PendingInvites, { matterId }], getPendingInvites, {
    enabled: !!matterId,
    refetchOnWindowFocus: false,
  });
};

export default useGetPendingInvites;
